import { stateDeleteApi } from "../../api/state/stateDeleteApi"

type PayloadShape = Parameters<typeof stateDeleteApi>[0]

export async function stateDeleteService(payload: PayloadShape, token: string) {
	return await stateDeleteApi(payload, token)
}
